import { createElementBlock as e, openBlock as o, createStaticVNode as a } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(i, t) {
  return o(), e("svg", l, t[0] || (t[0] = [
    a('<g clip-path="url(#ic_payment_sofort_svg__a)"><path fill="#F4B6C7" stroke="#F4B6C7" stroke-width=".04" d="M20.47 23.5H4.029A3.01 3.01 0 0 1 1 20.47V4.028A3.01 3.01 0 0 1 4.028 1h16.443a3.01 3.01 0 0 1 3.028 3.028v16.4c.044 1.687-1.385 3.072-3.028 3.072Z"></path><path fill="#000" fill-rule="evenodd" d="M8.695 16.999h-2.13V7.053h2.13zm.393-4.957a5.63 5.63 0 0 0 3.152-4.993h2.238a7.57 7.57 0 0 1-2.393 5.417L15.089 17h-2.841zM15.093 15.582a1.42 1.42 0 1 0 2.842 0 1.42 1.42 0 0 0-1.421-1.421 1.42 1.42 0 0 0-1.42 1.42" clip-rule="evenodd"></path></g><defs><clipPath id="ic_payment_sofort_svg__a"><path fill="#fff" d="M0 0h24v24H0z"></path></clipPath></defs>', 2)
  ]));
}
const h = { render: r };
export {
  h as default,
  r as render
};
//# sourceMappingURL=ic_payment_sofort-CJvEf8CI.js.map
